import { PAYMENT_METHODS, SUBSCRIPTION_TRANSACTION_STATUS } from "./type";

export const paymentMethods = [
	{ name: "Cash", value: PAYMENT_METHODS.CASH },
	{ name: "Bank transfer", value: PAYMENT_METHODS.BANK_TRANSFER },
	{ name: "Abapay", value: PAYMENT_METHODS.ABAPAY_KHQR_DEEPLINK },
	{ name: "Credit card", value: PAYMENT_METHODS.CARDS },
	{ name: "Payway", value: PAYMENT_METHODS.PAYWAY },
];

export const subscriptionTransactionStatus = [
	{
		name: "New",
		value: SUBSCRIPTION_TRANSACTION_STATUS.new,
		color: "#4096ff",
	},
	{
		name: "Completed",
		value: SUBSCRIPTION_TRANSACTION_STATUS.success,
		color: "#73d13d",
	},
	// {
	// 	name: "Failed",
	// 	value: SUBSCRIPTION_TRANSACTION_STATUS.failed,
	// 	color: "#f5222d",
	// },
];
